<template>
  <div>
    <apexchart
      width="100%"
      height="350"
      type="bar"
      :options="options"
      :series="series"
    />
  </div>
</template>
<script>
import axios from "axios";
import { indexOf } from "lodash";
const lastWeekApi =
  "https://bookinga.herokuapp.com/api/v1/adminReport/company/lastweek";

export default {
  mounted() {
    var token = localStorage.getItem("jwt");
    const headers = { Authorization: `Bearer ${token}` };
    axios.get(lastWeekApi, { headers }).then((res) => {
      var data = res.data.result;
      var DaysMoney = [0, 0, 0, 0, 0, 0, 0];
      const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
      if (data)
        for (let i = 0; i < data.length; i++) {
          days.forEach((day) => {
            if (day == data[i].day) {
              if (DaysMoney[days.indexOf(day)] == 0) {
                DaysMoney.splice(days.indexOf(day), 1, Number(data[i].amount));
                // console.log(DaysMoney[days.indexOf(day)]);
              } else {
                DaysMoney.splice(
                  days.indexOf(day),
                  1,
                  DaysMoney[days.indexOf(day)] + Number(data[i].amount)
                );
              }
            }
          });

          this.series = [
            {
              name: "Income",
              data: DaysMoney,
            },
          ];
        }
    });
  },
  methods: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  data() {
    return {
      options: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: ["Mon", "Tues", "Wedn", "Thur", "Fri", "Sat", "Sun"],
        },
      },
      series: [],
    };
  },
};
</script>

<style></style>
